import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.modal');
import { OnInit, DoCheck, AfterViewChecked, OnDestroy, ElementRef, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

// The source builder renames Component. Keep per-document ownership independent
// of that generated class name; entries are only instances of this view.
const modalFocusOwners: object[] = [];
let nextModalId = 0;

@Component({
    selector: 'wiz-portal-season-modal',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.modal/view.scss */
:host {
  pointer-events: none;
}

.season-modal-root,
.season-modal-backdrop,
.season-modal-viewport {
  position: fixed !important;
  inset: 0 !important;
}

.season-modal-root {
  z-index: 1000 !important;
  pointer-events: auto;
}

.season-modal-backdrop {
  width: 100vw;
  height: 100dvh;
  background: rgba(37, 45, 41, 0.58);
  backdrop-filter: blur(3px);
}

.season-modal-viewport {
  width: 100vw !important;
  height: 100dvh;
  display: grid;
  place-items: center;
  padding: 24px;
  overflow: auto;
}

.season-modal-align {
  width: 100%;
  min-height: 100%;
  display: grid !important;
  place-items: center;
  padding: 0 !important;
}

.season-modal-panel {
  width: min(560px, 100%) !important;
  max-width: 560px !important;
  margin: auto !important;
  overflow: hidden;
  border: 1px solid #dce3da;
  border-radius: 16px;
  color: #283229;
  background: #fff;
  box-shadow: 0 26px 80px rgba(28, 39, 32, 0.24);
}

.season-modal-header {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) 34px;
  align-items: center;
  gap: 14px;
  padding: 24px 24px 16px;
}

.season-modal-icon {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: #537158;
  background: #eaf2e7;
}

.season-modal-icon svg {
  width: 23px;
  height: 23px;
}

.season-modal-heading {
  min-width: 0;
}

.season-modal-heading span,
.season-modal-heading h3 {
  display: block;
}

.season-modal-heading span {
  margin-bottom: 4px;
  color: #738075;
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
  letter-spacing: 0.1em;
}

.season-modal-heading h3 {
  margin: 0;
  color: #263027;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  line-height: 1.35;
}

.season-modal-close {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  color: #7e8980;
  background: #f3f5f1;
  cursor: pointer;
}

.season-modal-close:hover {
  color: #425145;
  background: #e9eee7;
}

.season-modal-close:focus-visible,
.season-modal-cancel:focus-visible,
.season-modal-action:focus-visible {
  outline: 2px solid var(--ro-focus, #005FCC);
  outline-offset: 3px;
}

.season-modal-close svg {
  width: 17px;
  height: 17px;
}

.season-modal-body {
  padding: 0 24px 24px 82px;
}

.season-modal-body p {
  margin: 0;
  color: #667169;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.75;
  white-space: pre-wrap;
}

.season-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 24px;
  border-top: 1px solid #e5e9e3;
  background: #f8faf7;
}

.season-modal-cancel,
.season-modal-action {
  min-width: 96px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
}

.season-modal-cancel {
  border: 1px solid #d4dbd2;
  color: #526056;
  background: #fff;
}

.season-modal-cancel:hover {
  border-color: #b9c5b7;
  background: #f4f7f2;
}

.season-modal-action {
  border: 1px solid #AE4327;
  color: #fff;
  background: #AE4327;
  box-shadow: 0 5px 14px rgba(69, 96, 72, 0.16);
}

.season-modal-action:hover {
  border-color: #8F351D;
  background: #8F351D;
}

.season-modal-action.is-error {
  border-color: #b94a40;
  background: #bf5045;
  box-shadow: 0 5px 14px rgba(171, 59, 50, 0.16);
}

.season-modal-action.is-error:hover {
  border-color: #a23e35;
  background: #a9443b;
}

.season-modal-action.is-warning {
  border-color: #b28736;
  background: #b58b3c;
  box-shadow: 0 5px 14px rgba(150, 107, 28, 0.16);
}

.season-modal-action.is-warning:hover {
  border-color: #996f25;
  background: #9f762b;
}

.season-modal-panel.is-success .season-modal-icon {
  color: #497550;
  background: #e6f2e5;
}

.season-modal-panel.is-warning .season-modal-icon {
  color: #926d27;
  background: #fff3d9;
}

.season-modal-panel.is-error .season-modal-icon {
  color: #aa443b;
  background: #fdeae7;
}

@media (max-width: 639px) {
  .season-modal-viewport {
    padding: 16px;
  }
  .season-modal-panel {
    margin: auto !important;
    border-radius: 16px;
  }
  .season-modal-header {
    grid-template-columns: 40px minmax(0, 1fr) 32px;
    gap: 11px;
    padding: 20px 18px 14px;
  }
  .season-modal-icon {
    width: 40px;
    height: 40px;
  }
  .season-modal-body {
    padding: 0 18px 20px;
  }
  .season-modal-actions {
    padding: 14px 18px 18px;
  }
  .season-modal-cancel,
  .season-modal-action {
    flex: 1;
    min-width: 0;
  }
}`],
})
export class PortalSeasonModalComponent implements OnInit, DoCheck, AfterViewChecked, OnDestroy {
    @Input() model: any = null;
    public actionPending = false;
    public readonly titleId = `season-modal-title-${++nextModalId}`;
    public readonly messageId = `${this.titleId}-message`;
    private panel: HTMLElement | null = null;
    private opener: HTMLElement | null = null;
    private opening = false;
    private destroyed = false;
    private focusMoved = false;
    private openingLocation = '';
    private inerted = new Map<HTMLElement, boolean>();

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef<HTMLElement>)  private element?: ElementRef<HTMLElement>) {
        if (!this.model) this.model = service.modal;
    }

    public async ngOnInit() {
    }

    public ngDoCheck() {
        const doc = this.element?.nativeElement.ownerDocument;
        if (!doc || this.destroyed) return;
        if (this.model?.isshow && !this.opening) {
            // Capture before *ngIf inserts the panel or background inert blurs it.
            this.opening = true;
            this.opener = doc.activeElement instanceof HTMLElement && doc.activeElement !== doc.body ? doc.activeElement : null;
            this.openingLocation = doc.defaultView?.location.href || '';
            this.focusMoved = false;
        } else if (!this.model?.isshow && this.opening) {
            this.releaseFocus();
            this.opening = false;
            this.opener = null;
        }
    }

    public ngAfterViewChecked() {
        if (this.destroyed || !this.opening || !this.model?.isshow) return;
        const panel = this.element?.nativeElement.querySelector<HTMLElement>('.season-modal-panel');
        if (!panel?.isConnected || !this.visible(panel)) return;
        if (panel !== this.panel) {
            this.releaseFocus(false);
            const previous = this.topOwner();
            const containsTop = previous?.panel && panel.contains(previous.panel);
            this.panel = panel;
            // Child view hooks can run before their parent's first view hook.
            if (containsTop) modalFocusOwners.splice(modalFocusOwners.indexOf(previous), 0, this);
            else { previous?.unlockBackground(); modalFocusOwners.push(this); }
            const doc = panel.ownerDocument;
            doc.addEventListener('keydown', this.modalKeydown, true);
            doc.addEventListener('focusin', this.trackFocus, true);
            if (containsTop) { panel.setAttribute('aria-modal', 'false'); return; }
            this.lockBackground();
            (this.items().find(node => node.matches('.season-modal-cancel')) || panel).focus({preventScroll: true});
        } else if (this.topOwner() === this && !this.focusMoved) {
            this.lockBackground();
        }
    }

    private topOwner(): this | undefined {
        const doc = this.element?.nativeElement.ownerDocument;
        return modalFocusOwners.filter(owner => (owner as this).panel?.ownerDocument === doc).slice(-1)[0] as this | undefined;
    }

    private visible(node: HTMLElement) {
        return node.isConnected && !node.closest('[hidden],[aria-hidden="true"]') && node.getClientRects().length > 0
            && !['hidden', 'collapse'].includes(node.ownerDocument.defaultView?.getComputedStyle(node).visibility || '');
    }

    private usable(node: HTMLElement) {
        return this.visible(node) && !node.matches(':disabled') && !node.closest('[inert]');
    }

    private items() {
        return Array.from(this.panel?.querySelectorAll<HTMLElement>('a[href],button,input:not([type="hidden"]),select,textarea,[tabindex]') || [])
            .filter(node => node.tabIndex >= 0 && this.usable(node));
    }

    private unlockBackground() {
        this.panel?.setAttribute('aria-modal', 'false');
        for (const [node, previous] of this.inerted) node.inert = previous;
        this.inerted.clear();
    }

    private lockBackground() {
        // Inert siblings along the live panel's path, never its ancestors/body.
        // Only the top common modal owns this map; nesting transfers it first.
        this.panel?.setAttribute('aria-modal', 'true');
        const wanted = new Set<HTMLElement>();
        let child = this.panel;
        const body = child?.ownerDocument.body;
        while (child?.parentElement && child !== body) {
            for (const sibling of Array.from(child.parentElement.children)) {
                if (sibling instanceof HTMLElement && sibling !== child) wanted.add(sibling);
            }
            child = child.parentElement;
        }
        for (const [node, previous] of this.inerted) {
            if (!wanted.has(node)) { node.inert = previous; this.inerted.delete(node); }
        }
        for (const node of wanted) {
            if (!this.inerted.has(node)) this.inerted.set(node, node.inert);
            if (!node.inert) node.inert = true;
        }
    }

    private trackFocus = (event: FocusEvent) => {
        if (this.topOwner() !== this || !this.panel || !this.model?.isshow) return;
        if (event.target !== this.panel.ownerDocument.body) this.focusMoved = !this.panel.contains(event.target as Node);
    };

    private modalKeydown = (event: KeyboardEvent) => {
        const panel = this.panel;
        if (!panel || this.topOwner() !== this || !this.model?.isshow || this.focusMoved || !this.visible(panel)
            || event.defaultPrevented || event.isComposing || event.keyCode === 229) return;
        if (event.key === 'Escape') {
            // Consume even a non-cancellable modal's Escape so a lower dialog
            // cannot close behind it. Pending retains the existing X/hide policy.
            event.preventDefault();
            event.stopImmediatePropagation();
            if (this.model.opts?.cancel && !event.repeat) void this.model.hide();
        } else if (event.key === 'Tab') {
            const items = this.items(), active = panel.ownerDocument.activeElement;
            const index = items.indexOf(active as HTMLElement);
            if (index < 0 || event.shiftKey && index === 0 || !event.shiftKey && index === items.length - 1) {
                event.preventDefault();
                event.stopImmediatePropagation();
                (event.shiftKey ? items[items.length - 1] || panel : items[0] || panel).focus({preventScroll: true});
            }
        }
    };

    private releaseFocus(restore = true) {
        const panel = this.panel;
        if (!panel) return;
        const doc = panel.ownerDocument, wasTop = this.topOwner() === this;
        const owned = !this.focusMoved && (panel.contains(doc.activeElement) || doc.activeElement === doc.body);
        doc.removeEventListener('keydown', this.modalKeydown, true);
        doc.removeEventListener('focusin', this.trackFocus, true);
        this.unlockBackground();
        modalFocusOwners.splice(modalFocusOwners.indexOf(this), 1);
        this.panel = null;
        if (!wasTop) return;
        const next = this.topOwner();
        if (next && !owned) next.focusMoved = true;
        if (next?.panel?.isConnected && next.model?.isshow && !next.focusMoved) next.lockBackground();
        if (!restore || !owned || !doc.hasFocus() || this.openingLocation !== (doc.defaultView?.location.href || '')) return;
        if (this.opener && this.opener.ownerDocument === doc && this.usable(this.opener)
            && (!next || next.panel?.contains(this.opener))) {
            this.opener.focus({preventScroll: true});
        } else if (next?.panel && next.model?.isshow && next.usable(next.panel)) {
            // The child caller may have disappeared while an outer modal stayed.
            (next.items().find(node => node.matches('.season-modal-cancel')) || next.panel).focus({preventScroll: true});
        }
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.releaseFocus();
        this.opening = false;
        this.opener = null;
    }

    public cancelLabel(): string {
        const cancel = this.model?.opts?.cancel;
        return cancel === true ? '취소' : typeof cancel === 'string' ? cancel : '';
    }

    public guardActionEnter(event: KeyboardEvent) {
        // Let the primary button's native Enter click own confirmation.
        if (event?.isComposing || event?.repeat || this.actionPending) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    public async confirmAction() {
        if (!this.model?.isshow || !this.model?.opts?.action || this.actionPending) return;
        this.actionPending = true;
        try {
            await this.model.action();
        } finally {
            this.actionPending = false;
        }
    }

    public modalStatus() {
        const status = String(this.model?.opts?.status || 'info').toLowerCase();
        return ['info', 'success', 'warning', 'error'].includes(status) ? status : 'info';
    }

    public modalStatusLabel() {
        const labels: any = {
            info: '변경 사항 확인',
            success: '처리 완료',
            warning: '주의 사항 확인',
            error: '작업 확인'
        };
        return labels[this.modalStatus()];
    }

    public btnColorClass() {
        const requested = String(this.model?.opts?.actionBtn || this.model?.opts?.status || 'primary').toLowerCase();
        const tone = ['error', 'warning'].includes(requested) ? requested : 'primary';
        return `season-modal-action is-${tone}`;
    }
}

export default PortalSeasonModalComponent;